import axios from "axios";
import Config from "@/config"

export default class RecipeService {
  getInstantPower(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("energy") + "/instant-power/" + serialNumber,
        options
      )
      .then(res => res.data);
  }

}
